import React from "react";

const Footer = () => {
    return (
        <>
            <footer id="footer">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-sm-11">
                            <div className="footer-logo">
                                {/* <a className="f-logo" href="#banner"><b>Feedmex</b></a> */}
                                <a className='navbar-brand' href="/"> <img src="images/logo.png"  alt="" /> </a>
                                <p>Turn Happy Customers Into Your Best Marketers.</p>
                                <div className="footer-social">
                                    <a href="https://www.facebook.com/mexyon/"><i className="fa fa-facebook" aria-hidden="true"></i></a>
                                    <a href="https://www.instagram.com/mexyonagency/"><i className="fa fa-instagram" aria-hidden="true"></i></a>
                                    <a href="https://www.linkedin.com/company/mexyon/"><i className="fa fa-linkedin" aria-hidden="true"></i></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-1"></div>
                        <div className="col-lg-2 col-sm-4">
                            <div className="links">
                                <h3>Product</h3>
                                <ul>
                                    <li><a href="/#overview">Features</a></li>
                                    {/* <li><a href="/pricing">Pricing</a></li> */}
                                    {/* <li><a href="/developer-docs">Integrations</a></li>
                                    <li><a href="/ApiDocumentation">Api Docs</a></li> */}
                                    {/* <li><a href="#">Privacy Site</a></li> */}
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-2 col-sm-6">
                            <div className="links">
                                <h3>Company</h3>
                                <ul>
                                    <li><a href="/about-us">About Us</a></li>
                                    {/* <li><a href="#">Recent Blogs</a></li> */}
                                     {/* <li><a href="/careers">Careers</a></li> */}
                                    <li><a href="/#contact">Contact Us</a></li>
                                    {/* <li><a href="/developer-docs">Developer Docs</a></li> */}
                                    {/* <li><a href="#">System Site</a></li> */}
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-2 col-sm-6">
                            <div className="links">
                                <h3>Legal</h3>
                                <ul>
                                    <li><a href="/privacy-policy">Privacy Policy</a></li>
                                    <li><a href="/terms-service">Terms of Service</a></li>
                                    {/* <li><a href="#">Share Money</a></li>
                                    <li><a href="#">Timing For Visit</a></li>
                                    <li><a href="#">Category</a></li> */}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            <section id="footer-btm">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="fop-btm text-center">
                                <h2>
                                    Copyright &copy; {new Date().getFullYear()}. All rights reserved by{" "}
                                    <a href="https://www.mexyon.com/">Mexyon</a>
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Footer;
